import { render, staticRenderFns } from "./add-recipient.vue?vue&type=template&id=50b78ddd&lang=pug"
import script from "./add-recipient.vue?vue&type=script&lang=js"
export * from "./add-recipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports